import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class Layout2Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
